import React from 'react';
import { Link } from 'react-router-dom';
import meats from '../assets/images/logo/test.jpg';
import { About } from '../About/About';
import { Services } from '../About/Services';
import { Products } from '../Products/Products';
import { t } from 'i18next';

// NEW clean, formal, modern homepage design
export const HomePage = () => {
  return (
    <div className="overflow-x-hidden w-full">
      {/* HERO SECTION */}
      <section className="w-full min-h-screen grid grid-cols-1 md:grid-cols-2 items-center bg-white px-6 md:px-16 py-16 gap-10">

        {/* LEFT SIDE - TEXT */}
        <div className="flex flex-col gap-6 order-2 md:order-1">
          <h1 className="text-4xl md:text-6xl font-extrabold text-[#1a0080] leading-tight">
            {t('homePage.heading1')}
          </h1>

          <p className="text-lg md:text-xl text-gray-700 max-w-md">
            {t('homePage.heading2')}
          </p>

          {/* Highlight Card */}
          <div className="bg-[#f7f5ff] border border-[#1a0080]/20 p-6 rounded-2xl shadow-md hover:shadow-xl transition-all">
            <p className="text-2xl font-semibold text-[#1a0080] mb-3">
              {t('homePage.title')}
            </p>
            <p className="text-gray-700 text-base leading-relaxed">
              {t('homePage.content')}
            </p>
          </div>

          {/* CTA BUTTON */}
          <Link
            to="/about"
            onClick={() => window.scrollTo(0, 0)}
            className="inline-block mt-4 px-6 py-3 text-white font-semibold bg-[#c2450b] rounded-xl shadow-md hover:bg-[#150066] transition-all"
          >
            {t('homePage.button')}
          </Link>
        </div>

        {/* RIGHT SIDE - IMAGE */}
        <div className="relative order-1 md:order-2 flex justify-center">
          <div className="w-[260px] md:w-[420px] h-[260px] md:h-[420px] rounded-full overflow-hidden shadow-2xl border-4 border-[#1a0080]">
            <img
              src={meats}
              alt="hero-img"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* OTHER SECTIONS */}
      <About />
      <Services />
      <Products />
    </div>
  );
};
